import ServiceBus from "servicestack/service-bus";
import labels from "emun.invoice/credit-request/_labels";
export const nav = 1;

export const getStates = (menu, mode = "credit-request", other = {}) => {
  const base = menu ? `${menu}.${mode}` : mode;
  return {
    [base]: {
      nav,
      menu, // <ui-view/>
      breadcrumbs: false,
      pageHeader: false,
      icon: "usd",
      title: labels.abbr + " Requests",
      url: "/" + mode + "?invoiceId", // + "?uploaded&mode",
      params: {},
      rerouteTo: `${base}.list`,
      resolve: {
        invoiceId: ($stateParams) => $stateParams.invoiceId,
        retailerId: ($stateParams) => $stateParams.retailerId,
      },
      templateProvider: ($stateParams) => `<credit-request-container 
         invoice-id="${$stateParams.invoiceId}" 
         retailer-id="${$stateParams.retailerId}" />`,
      ...other,
    },
    [`${base}.list`]: {
      menu: base,
      nav: false,
      breadcrumbs: false,
      pageHeader: false,
      icon: "usd",
      title: "List",
      resolve: {},
      templateProvider: ($stateParams) => `<credit-request-list />`,
    },
    [`${base}.detail`]: {
      menu: base,
      nav: false,
      url: "/{creditRequestId:[^/]+}",
      title: "Detail",
      breadcrumbs: false,
      pageHeader: false,
      params: {},
      resolve: {
        creditRequestId: ($stateParams) => $stateParams.creditRequestId,
      },
      templateProvider: ($stateParams) => `<credit-request-details credit-request-id="${$stateParams.creditRequestId}"/>`,
    },
    [`${base}.create`]: {
      menu: base,
      nav: false,
      url: "/{invoiceId:[^/]+}?status",
      title: "Detail",
      onEnter($state, $stateParams) {
        ServiceBus.send("CreateCreditMemoRequest.json?jsconfig=ua,uaa", {
          invoiceId: $stateParams.invoiceId,
          status: $stateParams.status || "Open",
        }).then(({ data }) => {
          console.debug("CreateCreditMemoRequest", data);
          $state.go("^.^.credit-request.detail", { creditRequestId: data.id });
        });
      },
    },
  };
};

export default getStates();
